import { Accordion, AccordionDetails, AccordionProps, AccordionSummary, Icon, Typography } from 'opensolar-ui'
import React, { forwardRef } from 'react'

export type AccordionPanelProps = AccordionProps & {
  /**
   * Title text displayed in the accordion summary header.
   */
  accordionSummaryTitle?: string

  /**
   * Optional icon displayed to the left of the summary title.
   */
  accordionSummaryLeftIcon?: React.ReactNode

  /**
   * Custom expand/collapse icon for the accordion summary.
   * Defaults to `keyboard_arrow_up`.
   */
  expandIcon?: React.ReactNode
}

/**
 * AccordionPanel is a wrapper component that combines
 * Accordion, AccordionSummary, and AccordionDetails into
 * a single reusable component.
 *
 * @component
 * @param {AccordionPanelProps} props - The props for AccordionPanel.
 * @returns {JSX.Element} A composed Accordion panel component.
 */

export const AccordionPanel = forwardRef<HTMLDivElement, AccordionPanelProps>((props, ref) => {
  const { accordionSummaryTitle, children, accordionSummaryLeftIcon, ...rest } = props
  return (
    <Accordion ref={ref} {...rest}>
      <AccordionSummary expandIcon={props.expandIcon || <Icon icon={'keyboard_arrow_up'} />}>
        {accordionSummaryLeftIcon && accordionSummaryLeftIcon}
        <Typography>{accordionSummaryTitle}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
})
